export const publicAuthorName = (author?: string | null): string => {
  if (!author) return 'Equipo de la Banda';
  return author.includes('@') ? 'Equipo de la Banda' : author;
};
